<template>
    <div class="member-list-table">
        <div class="search-wrapper">
            <el-button type="primary" @click="isAddMemberVisible = true">+添加会员</el-button>
            <more-operate ref="moreoperate">
                <div class="operate-detail-item">
                    <div @click="openMemberConfig">会员卡设置</div>
                    <div class="more-operate-item align-l" @click="$router.push('/main/member/memberImport')">批量导入会员</div>
                    <div>
                        <span class="fs-14 mr-37">分组展开</span>
                        <el-switch @change="changeisShowGroupHnadle" v-model="isShowGroup" />
                    </div>
                </div>
            </more-operate>
            <my-search 
                :styleData="{
                    placeholder: '输入会员昵称/手机号码',
                    width: '248px',
                    height: '36px'
                }"
                ref="mySearch"
                @searchData="searchData"/>
        </div>
        <member-group
            v-show="isShowGroup"
            ref="memberGroup"
            :keyword="oKeyword"
        />
        <el-table
            v-show="!isShowGroup"
            v-loading="isLoading"
            v-textHighlight="{
                keyword: oKeyword,
                indexs: [1],
                isBegin: !isLoading
            }"
            ref="elTable"
            :data="memberList"
            :height="'calc(100vh - 145px)'"
            :empty-text="isLoading ? ' ' : '暂无数据'"
            @sort-change="sortChange">
            <el-table-column type="index" label="#" />
            <el-table-column label="会员昵称" min-width="180">
                <template v-slot="{ row }">
                    <user-info v-if="row.user" :userInfo="{
                        avatar: row.user.avatar || '../../../assets/images/default_avatar.svg',
                        nickname: row.user.nickname,
                        realname: row.name,
                        gender: row.user.gender
                    }" />
                </template>
            </el-table-column>
            <el-table-column label="会员分组" min-width="160">
                <template v-slot:header="{ row }">
                    <table-data-filter
                        v-model="groupId"
                        allString="所有分组"
                        :title="'会员分组'"
                        :width="200"
                        :height="280"
                        :items="groupList"
                        @confirm="tableFilterConfirm"/>
                </template>
                <template v-slot="{ row }">
                    <p>{{ row.group.name }}</p>
                </template>
            </el-table-column>
            <el-table-column prop="birthday" label="生日" min-width="120" sortable="custom"/>
            <el-table-column prop="balance" label="会员余额(元)" min-width="160" align="right" sortable="custom">
                <template v-slot="{ row }">
                    <span class="pr-24 text-popper" v-textPopper v-numberAlign>{{ row.balance }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="accumulated_recharge" label="累计充值(元)" min-width="160" align="right">
                <template v-slot="{ row }">
                    <span class="text-popper" v-textPopper>{{ row.accumulated_recharge }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="accumulated_consume" label="累计消费(元)" min-width="160" align="right">
                <template v-slot="{ row }">
                    <span class="text-popper" v-textPopper>{{ row.accumulated_consume }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="accumulated_consume_count" label="累计消费次数" min-width="160" align="right">
                <template v-slot="{ row }">
                    <span class="text-popper" v-textPopper>{{ row.accumulated_consume_count }}</span>
                </template>
            </el-table-column>
            <el-table-column min-width="20"/>
            <el-table-column label="操作" width="80">
                <template v-slot="{ row }">
                    <div class="operate fx-v-center">
                        <button class="text-btn" @click="$router.push({
                            path: '/main/member/memberDetail',
                            query: {
                                id: row.id
                            }
                        })">详情</button>
                        <!-- <i class="fx-v-center iconfont iconmore_about">更多</!-->
                    </div>
                </template>
            </el-table-column>
            <p v-if="isHasMore && isScrollLoading" slot="append" style="text-align: center; padding: 10px;">
                <span class="loading-step-animation">正在加载...</span>
            </p>
            <p v-if="(!isHasMore) && memberList.length > 0" slot="append" style="text-align: center; padding: 10px;">没有更多了</p>
        </el-table>
        <!-- component -->
        <add-member headerTitle='添加会员' 
            :qrCodeUrl="qrCodeUrl"
            :visible.sync="isAddMemberVisible"
            :content="'顾客使用微信扫描下方小程序码，顾客注册后即可成为本店铺会员。'"/>
        <MemberConfig 
            :visible.sync='isMemberConfigVisible'
            ref="memberConfig"
        />
    </div>
</template>

<script lang="tsx">
import TableDataFilter from '@/components/table_data_filter/table_data_filter.vue'
import MySearch from '@/components/search/search.vue'
import MoreOperate from '@/components/more_operate/more_operate.vue'
import AddMember from '../modules/add_member.vue'
import { ref, createComponent, SetupContext, onBeforeMount, onMounted, watch } from '@vue/composition-api'
import { openMessage, useScrollLoad, openRenewMessage } from '@/utils/system.tsx'
import $fetch from '@/api'
import clone from 'lodash/cloneDeep'
import { setObjectItemToFixed } from '@/utils/index'
import MemberConfig from '../member_config/member_config.vue'
import MemberGroup from './modules/member_group.vue'
import { editionJudge } from '../../../utils/editionJudge'

export default createComponent({
    setup(props, ctx: SetupContext) {
        const qrCodeUrl = ref('')
        const oKeyword = ref('')
        const oOrderBy = ref<number | undefined>()
        const oOrderMethod = ref<number | undefined>()
        const isShowGroup = ref(localStorage.getItem('newLsShowMemberGroup') ? true : false)
        const memberList = ref([])
        const isAddMemberVisible = ref(false)
        const isMemberConfigVisible = ref(false)
        const groupList = ref<any[]>([])
        const groupId = ref<number[]>([])
        const isLoading = ref(false)
        const {
            page: oPage,
            isHasMore,
            isLoading: isScrollLoading,
            bindListener,
            initScrollLoad
        } = useScrollLoad()

        const orderByMap = {
            birthday: 'birthday',
            balance: 'balance',
            accumulated_recharge: 'accumulated_recharge',
            accumulated_consume: 'accumulated_consume',
            accumulated_consume_count: 'accumulated_consume_count'
        }

        const orderMethedMap = {
            null: undefined,
            descending: false,
            ascending: true
        }

        // 组件的入口
        onBeforeMount(() => {
            isLoading.value = true
            getQrCode()
            getGroups()
            getMemberList()
                .then(() => isLoading.value = false)
        })

        onMounted(() => {
            bindListener({
                dom: (ctx.refs.elTable as any).$el.querySelector('.el-table__body-wrapper'),
                loadFunction: getMemberList
            })
        })

        const changeisShowGroupHnadle = (val) => {
            if (val) {
                localStorage.setItem('newLsShowMemberGroup', 'true')
            } else {
                localStorage.setItem('newLsShowMemberGroup', '')
            }
            setTimeout(hideMoreOperate, 500)
            ctx.root.$nextTick(() => {
                (ctx.refs.mySearch as any).clear()
            })
        }

        const getQrCode = () => {
            return $fetch.post({
                url: '/membership/getshopmembercardadmin'
            }).then(data => {
                console.log('二维码', data)
                qrCodeUrl.value = data.acode_url
            }).catch(e => openMessage('error', e.message || '获取二维码失败'))
        }

        const getMemberList = (page: number = oPage.value, limit: number = 20, groupIds: number[] = groupId.value, keyword: string | undefined = oKeyword.value || undefined, orderBy: number | undefined = oOrderBy.value, orderMethod: number | undefined = oOrderMethod.value) => {
            const params: {
                page: number,
                limit: number,
                member_filter: any[],
                order_by?: number,
                desc?: number,
                keyword?: string
            } = {
                page,
                limit,
                member_filter: [{
                    filter_type: '0',
                    group_ids: groupIds || []
                }],
                order_by: orderBy,
                desc: orderMethod,
                keyword
            }
            return $fetch.post({
                url: '/membership/getmemberlist',
                params,
            }).then(data => {
                data = setObjectItemToFixed(data)
                if (page === 1) {
                    memberList.value = []
                    ctx.root.$nextTick(() => {
                        memberList.value = data.member_list
                        initScrollLoad(data)
                    })
                } else {
                    memberList.value = memberList.value.concat(data.member_list)
                }
                return data
            }).catch(e => openMessage('error', e.message || '获取会员列表失败'))
        }

        const tableFilterConfirm = () => {
            oPage.value = 1
            isHasMore.value = true
            isLoading.value = true
            getMemberList().then(() => isLoading.value = false)
        }

        const searchData = (value: string, type: string) => {
            oKeyword.value = value
            if (isShowGroup.value) {
                (ctx.refs.memberGroup as any).setKeyword(value)
            } else {
                oPage.value = 1
                isLoading.value = true
                getMemberList().then(() => isLoading.value = false)
            }
        }

        const sortChange = ({ column, prop, order }) => {
            oOrderMethod.value = orderMethedMap[order]
            oOrderBy.value = oOrderMethod.value == null ? undefined : orderByMap[prop]
            oPage.value = 1
            isLoading.value = true
            getMemberList()
                .then(() => isLoading.value = false)
        }

        const hideMoreOperate = () => {
            (ctx.refs.moreoperate as any).hide()
        }

        const openMemberConfig = () => {
            (ctx.refs.memberConfig as any).open()
            hideMoreOperate()
        }

        function getGroups() {
            return $fetch.post({
                url: '/membership/getmembergrouplist',
            }).then(data => {
                console.log('会员分组', clone(data))
                groupList.value = data
                groupId.value = data.map(item => item.id)
            }).catch(e => {
                openMessage('error', e.message)
            })
        }

        return {
            // data
            isAddMemberVisible,
            isMemberConfigVisible,
            isShowGroup,
            memberList,
            isScrollLoading,
            isLoading,
            isHasMore,
            qrCodeUrl,
            oKeyword,
            groupList,
            groupId,
            // methods
            searchData,
            sortChange,
            openMemberConfig,
            tableFilterConfirm,
            changeisShowGroupHnadle
        }
    },

    components: {
        TableDataFilter,
        MySearch,
        MoreOperate,
        AddMember,
        MemberConfig,
        MemberGroup
    }
})
</script>

<style lang="scss" scoped>
::v-deep .el-button {
    width: 100px;
    margin-right: 12px;
    padding-left: 0;
    padding-right: 0;
    text-align: center;
    box-sizing: border-box;
}

.operate-detail-item {
    color: #333;

    > div {
        height: 36px;
        padding: 0 8px;
        line-height: 36px;
        cursor: pointer;

        &:hover {
            background: #F7F7F7;
        }
    }
}

.fx-v-center {
    display: inline-flex;
    align-items: center;
}

.member-list-table {
    position: relative;
}

.search-wrapper {
    position: absolute;
    right: 0;
    top: -54px;
    display: flex;
    align-items: center;
}

.operate {
    .text-btn {
        flex: none;
        padding: 0;
        margin-right: 20px;
    }

    .iconmore_about {
        color: #333;
        font-size: 14px;
        ;
        cursor: pointer;

        &::before {
            margin-right: 6px;
            color: #979797;
            font-size: 20px;
        }
    }
}
</style>